export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_complete_4.8c643f51.jpg";